import _ from 'lodash'
import React from 'react'

import { Field, reduxForm } from 'redux-form'

class DefectAreaEdit extends React.Component {

    render () {
        const { handleSubmit, submitting, onSubmit, errors, goBack, projectId, initialValues } = this.props
        if (!initialValues) return (<div/>)
        return(
            <div>
                <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
                    <h4 className="tx-gray-800 mg-b-5">แก้ไขบริเวณที่เกิดข้อบกพร่อง</h4>
                </div>
                <div className="br-pagebody">
                    <div className="br-section-wrapper">
                        <form onSubmit={handleSubmit((values) => {
                            onSubmit(values)
                        })}>
                            <div className="row align-items-center justify-content-center">
                                <div className="col-md-12">
                                    <div className="form-layout form-layout-5">
                                        <div className="">
                                            <div className="row mg-t-20">
                                                <label htmlFor="project" className="col-sm-4 form-control-label">โครงการ : <span className="tx-danger">&nbsp;*</span></label>
                                                <div className="col-sm-6">
                                                    <Field name="projectName" component="input" className="form-control" disabled={true}/>
                                                </div>
                                            </div>
                                            <div className="row mg-t-20">
                                                <label htmlFor="mainArea" className="col-sm-4 form-control-label">พื้นที่หลัก : <span className="tx-danger">&nbsp;*</span></label>
                                                <div className="col-sm-6">
                                                    <Field name="mainArea.name" component="input" type="text"
                                                           className="form-control" disabled={true}/>
                                                </div>
                                            </div>
                                            <div className="row mg-t-20">
                                                <label htmlFor="name" className="col-sm-4 form-control-label form-label-custom">บริเวณที่เกิดข้อบกพร่อง : <span className="tx-danger">&nbsp;*</span></label>
                                                <div className="col-sm-6">
                                                    <Field name="name" component="input" type="text" placeholder="Defect Area" className="form-control"/>
                                                    {errors.name ? <span className="text-danger">{errors.name}</span> : undefined}
                                                </div>
                                            </div>

                                            <div className="row mg-t-30">
                                                <div className="col-sm-8 mg-l-auto">
                                                    <div className="form-layout-footer">
                                                        <button type="submit" className="btn btn-teal" disabled={submitting}>แก้ไขบริเวณที่เกิดข้อบกพร่อง</button>
                                                        <span>&nbsp;&nbsp;&nbsp;</span>
                                                        <button type="button" className="btn btn-secondary" disabled={submitting} onClick={goBack}>กลับ</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default reduxForm({
    form: 'defect-area-edit',
    enableReinitialize: true,
})(DefectAreaEdit)


// WEBPACK FOOTER //
// ./src/components/DefectAreaEdit.js